module.exports = __webpack_public_path__ + "static/img/PFK_OurTeam_Photo1_800x290.d5dc4df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurTeam_Photo1_800x290.jpg
// module id = 328
// module chunks = 2